import { render, staticRenderFns } from "./GrButton.vue?vue&type=template&id=d5a60aa0&scoped=true&"
import script from "./GrButton.vue?vue&type=script&lang=ts&"
export * from "./GrButton.vue?vue&type=script&lang=ts&"
import style0 from "./GrButton.vue?vue&type=style&index=0&id=d5a60aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a60aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
